import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src431700410/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .CO registrations</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>Definitions:</strong>
    </p>
    <blockquote>
  <p>
    Administrator: .Co Internet S.A.S., (“Administrator”) was appointed by the
    Ministry of Information Technologies and Communications of the Republic of
    Colombia as the designated manager for the .co country code top-level domain
    and redelegation has been approved by ICANN and executed in early February
    2010
  </p>
    </blockquote>
    <p>
  <strong>The Registrant agrees to the following:</strong>
    </p>
    <blockquote>
  <p>
    1. The data provided in the domain name registration application is true,
    correct, current and complete and Applicant will ensure that all such
    information is kept up to date;{' '}
  </p>
  <p>
    2. Neither the registration nor the use of the requested domain name
    interferes with or infringes upon the lawful rights of any person;
  </p>
  <p>
    3. The domain name has not been registered for and will not be used for any
    purpose that is fraudulent, illegitimate or otherwise in conflict with any
    applicable laws, rules, regulations, ordinances or decrees, including,
    without limitation for the submission of unsolicited bulk e-mail, phishing,
    pharming use of botnets or malware, infringement of the legitimate trademark
    rights of others, or any other abusive practices;{' '}
  </p>
  <p>
    4. The Applicant has the full power and authority to enter into the
    Registration Agreement on behalf of the Registrant and will be responsible
    for any errors, falsifications or omissions of information.{' '}
  </p>
  <p>
    5. That the registration and exclusive and perpetual right of use and
    enjoyment for any Registered Name may be cancelled if Administrator,
    REGISTRAR or its providers determines that Registrant has provided
    information that is incorrect, false or inaccurate either in the initial
    registration process or in any subsequent communications or in the event
    Applicant violates any of the terms of the Registration Agreement.
  </p>
  <p>
    6. To follow and be bound by all Administrator Policies (including, without
    limitation, the Administrator Privacy Policy), as the same may be updated,
    modified or replaced from time to time, and to subject themselves to any
    dispute resolution process for the resolution of disputes regarding
    Registered Names that may be adopted by Administrator, as the same may be
    updated, modified or replaced from time to time, including, but not limited
    to, any expedited processes for suspension of a domain name due to claims
    sought by intellectual property right holders.{' '}
  </p>
  <p>
    7. That the domain name may be suspended, terminated, canceled or
    transferred in the interest of safeguarding compliance with security of the
    Systems involved in the .CO Registration System or registration policies or
    as a result of a dispute resolution.{' '}
  </p>
  <p>
    8. That all official contact, correspondence and/or other information sent
    from or on behalf of REGISTRAR, its providers, Administrator, or any other
    relevant official will be transmitted to the administrative contact
    information that appears in the Registry Database and that the designated
    administrative contact is authorized to receive all such communication and
    information.{' '}
  </p>
  <p>
    9. That Registrant gives its consent and authorization to REGISTRAR, its
    providers, and Administrator to publish the following information in the
    WHOIS database and elsewhere:
  </p>
  <blockquote>
    <p>
      (i) Names, addresses, telephone numbers and email addresses of the
      Registrant and Registrant’s designated administrative, technical and
      billing contacts.
    </p>
    <p>
      (ii) Dates related to the creation, last update and expiration of the
      Registered Name.
    </p>
  </blockquote>
  <p>
    10. That all disputes, claims or controversies regarding the registration,
    ownership, use, transfer, assignment, loss, cancellation, or suspension of
    any Registered Name or otherwise relating to the .Co TLD between the
    Registrant and the Administrator, or the providers employed to access
    Administrator´s Systems shall be governed exclusively by the laws of
    Colombia and that any such disputes, claims or controversies shall be
    brought and heard exclusively in the courts located in Bogotá,
    Colombia.{' '}
  </p>
  <p>
    11. That Registrant assumes all responsibility and liability arising out of
    any assignment by Registrant of the Registered Name, including, without
    limitation, with respect to any users, clients, customers, licensees or
    other persons who may be using any sub-­-domain of the Registered Name or
    any Website associated with the Registered Name.
  </p>
  <p>
    12. That neither REGISTRAR’s acceptance of the Applicant’s registration
    request nor the actual registration of any Registered Domain shall be deemed
    an indication that Administrator, REGISTRAR, its providers, or the Colombian
    Government has made any determination regarding the legality of the
    registration, the extent to which Registrant’s registration and exclusive
    and perpetual right of use and enjoyment of the Registered Name may violate
    any applicable laws, rules, regulations, policies, procedures, ordinances or
    decrees or infringe on the rights of any other person, and that neither
    Administrator, REGISTRAR, its providers nor the Colombian Government shall
    have any liability or responsibility arising therefrom.
  </p>
  <p>
    13. That Registrant shall be bound by the terms and conditions of the
    initial launch and general operation of the .Co TLD, including without
    limitation the Sunrise and Landrush periods, and the corresponding dispute
    resolution policies, and that Administrator, REGISTRAR or its providers
    shall have no liability of any kind for any loss or liability resulting
    from{' '}
  </p>
  <blockquote>
    <p>
      (a) the ability or inability of an Applicant to obtain a Registered Name
      during these periods, or (b) the results of any dispute procedures.
    </p>
  </blockquote>
  <p>14. Information To Be Collected From Registrants</p>
  <p>
    To register a name, Registrants must provide the following minimum
    registration information:{' '}
  </p>
  <blockquote>
    <p>a) The domain name registered;</p>
    <p>
      b) The IP address and corresponding names of the primary and secondary
      name servers for the Registered Name;
    </p>
    <p>c) The original creation date and term of the registration;</p>
    <p>
      d) The name, postal address, e-mail address, voice telephone number, and
      (where available) fax number of the Registrant of the Registered Name;
    </p>
    <p>
      e) The name, postal address, e-mail address, voice telephone number, and
      (where available) fax number of the technical contact for the Registered
      Name; and
    </p>
    <p>
      f) The name, postal address, e-mail address, voice telephone number, and
      (where available) fax number of the administrative contact for the
      Registered Name.
    </p>
  </blockquote>
    </blockquote>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      